module.exports = __webpack_public_path__ + "public/img/PMS - Header Banner 1.e99f5d29.png";